import "./managelist.css";
import SearchFilter from "./SearchFilter";

const Managelisting = () => (
  <main className="listing-page">
    <header className="listing-page__intro">
      <div className="listing-page__intro-copy">
        <p className="listing-page__eyebrow">STOCK &amp; CATALOG</p>
        <h1>Manage listings</h1>
        <p className="listing-page__description">
          Review book details, check availability, and update catalog listings.
        </p>
      </div>
      <div className="listing-page__module" aria-label="Inventory catalog">
        <span className="listing-page__module-mark" aria-hidden="true">ML</span>
        <span className="listing-page__module-copy">
          <span>Inventory module</span>
          <strong>Book catalog</strong>
        </span>
      </div>
    </header>
    <SearchFilter />
  </main>
);

export default Managelisting;
